import React from 'react';
import { useFitStore } from '../store/useFitStore';
import Card from '../components/shared/Card';
import { formatDistanceToNow } from 'date-fns';

// Feed timestamps may be a Firestore Timestamp (live), a plain Date (demo),
// a { seconds } object, or an ISO string. Normalise to a JS Date safely.
const toJsDate = (value: any): Date | null => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value.seconds === 'number') return new Date(value.seconds * 1000);
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

const Community: React.FC = () => {
  const { user, feedEvents, toggleReaction } = useFitStore();

  const getIcon = (type: string) => {
    switch (type) {
      case 'PR': return '🏆';
      case 'STREAK': return '🔥';
      case 'COMPLETION': return '✅';
      case 'FORM_CHECK': return '🎥';
      default: return '📢';
    }
  };

  return (
    <div className="main-content">
      <header style={{ marginBottom: 'var(--spacing-xl)' }}>
        <h1 className="text-accent" style={{ fontSize: '2.2rem', fontWeight: 900 }}>The Tribe</h1>
        <p className="text-muted">Real-time wins from the roster.</p>
      </header>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-lg)' }}>
        {feedEvents.length > 0 ? feedEvents.map((event) => {
          const hasReacted = event.reactions?.[user?.id || ''];
          const reactionCount = Object.keys(event.reactions || {}).length;

          return (
            <Card key={event.id} variant="glass" padding="var(--spacing-lg)" className="animate-slide-up">
              <div style={{ display: 'flex', gap: 'var(--spacing-md)' }}>
                <div style={{ 
                  width: '48px', height: '48px', borderRadius: '50%', 
                  background: 'var(--bg-tertiary)', display: 'flex', 
                  alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem',
                  border: '1px solid var(--glass-border)'
                }}>
                  {getIcon(event.type)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ fontSize: '1rem', fontWeight: 800 }}>{event.userName}</h3>
                    <span style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>
                      {toJsDate(event.timestamp) ? formatDistanceToNow(toJsDate(event.timestamp)!) + ' ago' : 'Just now'}
                    </span>
                  </div>
                  <p style={{ fontSize: '0.95rem', fontWeight: 700, color: 'var(--accent-secondary)', margin: '2px 0' }}>{event.title}</p>
                  <p className="text-primary" style={{ fontSize: '0.9rem', lineHeight: 1.4 }}>{event.description}</p>
                  
                  <div style={{ marginTop: 'var(--spacing-md)', display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
                    <button 
                      onClick={() => toggleReaction(event.id)}
                      style={{ 
                        background: hasReacted ? 'var(--accent-primary)' : 'var(--bg-tertiary)',
                        color: hasReacted ? 'var(--bg-primary)' : 'white',
                        padding: '6px 12px', borderRadius: 'var(--radius-full)',
                        fontSize: '0.75rem', fontWeight: 800, display: 'flex', alignItems: 'center', gap: '6px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      🙌 {reactionCount > 0 && reactionCount}
                    </button>
                  </div>
                </div>
              </div>
            </Card>
          );
        }) : (
          <div style={{ textAlign: 'center', padding: 'var(--spacing-xl)' }}>
            <p className="text-muted">The feed is quiet... go hit a PR!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Community;
